/**
 * CRM Tasks Async Thunks
 * All async actions for CRM task operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as crmTasksApi from '../api/crmTasksApi';

/**
 * Fetch tasks with filters
 */
export const fetchTasksThunk = createAsyncThunk(
  'crmTasks/fetchTasks',
  async (params, { rejectWithValue }) => {
    try {
      const data = await crmTasksApi.fetchTasks(params);
      return data;
    } catch (error) {
      console.error('Error fetching tasks:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Create new task
 */
export const createTaskThunk = createAsyncThunk(
  'crmTasks/createTask',
  async (data, { rejectWithValue }) => {
    try {
      const result = await crmTasksApi.createTask(data);
      return result;
    } catch (error) {
      console.error('Error creating task:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Update task
 */
export const updateTaskThunk = createAsyncThunk(
  'crmTasks/updateTask',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const result = await crmTasksApi.updateTask(id, data);
      return result;
    } catch (error) {
      console.error('Error updating task:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Delete task
 */
export const deleteTaskThunk = createAsyncThunk(
  'crmTasks/deleteTask',
  async (id, { rejectWithValue }) => {
    try {
      const data = await crmTasksApi.deleteTask(id);
      return data;
    } catch (error) {
      console.error('Error deleting task:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
